import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3a76d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "type"]
const _hoisted_2 = { class: "b-push-button__button inter-regular color--text-primary fs-sm" }

import { CSSProperties, PropType } from 'vue';
  import SpinnerComponent from '@/views/components/SpinnerComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PushButton',
  props: {
    variant: {
      type: String as PropType<'primary' | 'secondary' | 'transparent'>,
      default: 'primary',
    },
    size: {
      type: String as PropType<'large' | 'normal' | 'small' | 'compact'>,
      default: 'large',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<'button' | 'submit'>,
      default: 'button',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    borderRadius: {
      type: String as PropType<CSSProperties['border-radius']>,
    },
  },
  setup(__props) {

const props = __props

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["b-push-button", [
      'b-push-button',
      `b-push-button--${props.variant}`,
      `b-push-button--size-${props.size}`,
      { 'b-push-button--disabled': __props.disabled },
      { 'b-push-button--loading': __props.isLoading },
    ]]),
    disabled: __props.disabled,
    type: __props.type,
    style: _normalizeStyle({ borderRadius: __props.borderRadius })
  }, [
    (__props.isLoading)
      ? (_openBlock(), _createBlock(SpinnerComponent, {
          key: 0,
          class: "b-push-button__loader",
          color: "var(--neutral-text-primary)"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 14, _hoisted_1))
}
}

})